import { Box } from '@mui/material';
import React from 'react';
import { SimpleForm, ReferenceInput, FormDataConsumer, required } from 'react-admin';
import { EditToolbar } from '../../layout/EditToolbar';
import { TitleLengthCheck } from '../../lib/CommonComponents';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { AutocompleteInput, TextInput } from '../../lib/wrappers/Inputs';
import { useAzureADGroups } from '../../msal/useAzureADGroups';

export const ResearchModuleInputs = () => {
    const { canEditCourseAndModule } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
            <SimpleForm toolbar={<EditToolbar />}>
                <Box display="flex" width={1}>
                    <Box flex={2}>
                        <TextInput source="moduleCode" fullWidth />
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <TextInput source="shortTitle" validate={[required(), TitleLengthCheck]} fullWidth />
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <TextInput source="welshTitle" fullWidth />
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={2}>
                        <ReferenceInput
                            reference="ModuleType"
                            source="moduleTypeId"
                            fullwidth
                        >
                            <AutocompleteInput optionText="description" />
                        </ReferenceInput>
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <TextInput source="description" fullWidth />
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={3}>
                        <ReferenceInput
                            label="Faculty"
                            reference="Faculty"
                            source="facultyId"
                            fullWidth
                        >
                            <AutocompleteInput optionText="description" />
                        </ReferenceInput>
                    </Box>
                    <Box flex={3} ml="0.5em">
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.facultyId ? (
                                <ReferenceInput
                                    reference="FacultyGroup"
                                    label="myroot.FacultyGroup"
                                    source="departmentId"
                                    filter={{ faculty_id: formData.facultyId }}
                                    {...rest}
                                    fullWidth
                                >
                                    <AutocompleteInput optionText="description" />
                                </ReferenceInput>
                            ) : null}
                        </FormDataConsumer>
                    </Box>
                    <Box flex={3} ml="0.5em">
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.departmentId ? (
                                <ReferenceInput
                                    reference="FacultySubGroup"
                                    label="myroot.FacultySubGroup"
                                    source="subjectId"
                                    filter={{
                                        facultygroup_id: formData.departmentId
                                    }}
                                    {...rest}
                                    fullWidth
                                >
                                    <AutocompleteInput optionText="description" />
                                </ReferenceInput>
                            ) : null}
                        </FormDataConsumer>
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={2}>
                        <ReferenceInput
                            reference="CreditValue"
                            source="creditValueId"
                            fullWidth
                        >
                            <AutocompleteInput optionText="creditvalue" />
                        </ReferenceInput>
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <ReferenceInput
                            reference="CreditLevel"
                            source="creditLevelId"
                            fullWidth
                        >
                            <AutocompleteInput optionText="Title" />
                        </ReferenceInput>
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <ReferenceInput reference="Status" source="statusId" fullWidth>
                            <AutocompleteInput optionText="Title" />
                        </ReferenceInput>
                    </Box>
                </Box>
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};
